import React from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Link } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const ReportPlaceholderWarning = ({severity, titleTranslationKey, bodyTranslationKey}) => {
    const { t } = useTranslation();

    return <Alert severity={severity} variant='filled' sx={{ maxWidth: '40em' }}>
        <AlertTitle>{ t(titleTranslationKey) }</AlertTitle>

        <Trans
            i18nKey={bodyTranslationKey}
            components={{ emailSupportLink: <Link color="warning.contrastText" href="mailto:support@visionslive.com" /> }}
        />
    </Alert>;
};

ReportPlaceholderWarning.propTypes = {
    severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
    titleTranslationKey: PropTypes.string,
    bodyTranslationKey: PropTypes.string
};

export default ReportPlaceholderWarning;
